module.exports = __webpack_public_path__ + "img/home-05-panoramic-layer-01.ac3b9b76.jpg";